import { ContractNavigationEnum } from 'v3/data/store/contractCard/enum';
import { ContractStepperEnum } from './enum';
import { IContractStepperState } from './types';

export const contractStepperInitialState: IContractStepperState[] = [
  {
    name: ContractStepperEnum.TokenStep,
    label: '1',
    steps: [
      ContractNavigationEnum.INITIAL,
      ContractNavigationEnum.TOKEN_REQUESTED,
      ContractNavigationEnum.TOKEN_VERIFIED,
    ],
    isCompleted: false,
    error: false,
  },
  {
    name: ContractStepperEnum.DeviceDetails,
    label: '2',
    steps: [ContractNavigationEnum.DEVICE_DETAILS],
    isCompleted: false,
    error: false,
  },
  {
    name: ContractStepperEnum.ContractSignature,
    label: '3',
    steps: [ContractNavigationEnum.SIGN_CONTRACT, ContractNavigationEnum.CONTRACT_COMPLETED],
    isCompleted: false,
    error: false,
  },
];
